import { render } from "./PlayBuilder.vue?vue&type=template&id=2abb7f96"
import script from "./PlayBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayBuilder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Playbooks/PlayBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2abb7f96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2abb7f96', __exports__)) {
    api.reload('2abb7f96', __exports__)
  }
  
  module.hot.accept("./PlayBuilder.vue?vue&type=template&id=2abb7f96", () => {
    api.rerender('2abb7f96', render)
  })

}


export default __exports__